export const demoPatient = {
  nombre: "Maria Lopez",
  edad: 78,
  sexo: "Femenino",
};

export const demoConsultation = {
  fecha: "07/04/2026",
  motivo: "Olvidos recientes y control de enfermedades cronicas",
  antecedentes: [
    "Hipertension arterial en tratamiento",
    "Diabetes mellitus tipo 2 controlada",
    "Vive con su hija, mantiene autonomia parcial",
  ],
  escalas: [
    { nombre: "Indice de Barthel", valor: "80/100", interpretacion: "Dependencia leve" },
    { nombre: "Mini-Cog", valor: "Positivo", interpretacion: "Tamizaje positivo para deterioro cognitivo" },
    { nombre: "TUG", valor: "14 s", interpretacion: "Riesgo de caidas leve-moderado" },
    { nombre: "PHQ-9", valor: "6/27", interpretacion: "Depresion leve" },
  ],
  resumenClinico:
    "Paciente con deterioro cognitivo leve probable y riesgo funcional moderado. Requiere seguimiento cognitivo, fortalecimiento de movilidad y ajuste de plan de autocuidado familiar.",
};

export const demoDocument = {
  medico: "Dra. Ana Morales - Geriatria",
  clinica: "Aurora Geriatrica Centro Clinico",
  hallazgos: [
    "Deterioro cognitivo leve probable en tamizaje inicial",
    "Riesgo de caidas por velocidad de marcha disminuida",
    "Dependencia leve en actividades basicas",
  ],
  impresion:
    "Sindorme geriatrico mixto de riesgo cognitivo-funcional con necesidad de seguimiento clinico y plan preventivo en domicilio.",
  plan: [
    "Seguimiento clinico en 6 semanas",
    "Estimulación cognitiva diaria guiada por cuidador",
    "Programa de ejercicios de equilibrio y fuerza 3 veces por semana",
    "Educacion a familiar sobre signos de alarma y adherencia terapeutica",
  ],
};
